import React, { useState } from 'react';
import './Footer.css';
import { Button, Col, Container, Form, FormControl, FormGroup, Row } from 'react-bootstrap';
import { BsInstagram } from "react-icons/bs";
import { RiFacebookCircleLine } from "react-icons/ri";
import { FiYoutube,FiTwitter } from "react-icons/fi";
import { BsTelephone } from "react-icons/bs";
import { GiLinkedRings, GiRotaryPhone } from "react-icons/gi";
import { AiOutlineMail } from "react-icons/ai";
import { NavLink } from 'react-router-dom';
import {BsWhatsapp} from 'react-icons/bs';
import {FaLinkedinIn} from 'react-icons/fa';
import {FaUserTie} from 'react-icons/fa';
import QR from '../../images/QR.png';
import GoogleMap from '../../images/GoogleMap.png';
import MyVerticallyCenteredModal from '../ModalP/index';
import PrivacyModal from '../PrivacyModal';
import RefundModal from '../RefundModal';
import RulesModal from '../RulesModal';
import { HashLink as Link } from 'react-router-hash-link';
import { Nav,
    NavbarContainer,
    NavbarContainer2,
    NavLogo,
    MobileIcon,
    NavMenu,
    NavItem,
    NavLinks,
    NavBtn,
    NavBtnLink, 
    NavLinksAbout} from '../Navbar/NavbarElements';
import {useDispatch } from 'react-redux';
import {useNavigate} from 'react-router-dom';




function Footer() {
    const [modalShow, setModalShow] = useState(false);
    const [PrivacymodalShow, setPrivacyModalShow] = useState(false);
    const [RefundmodalShow, setRefundModalShow] = useState(false);
    const [RuleManagementShow, setRuleManagementShow] = useState(false);
    const [user,setUser]= useState(JSON.parse(localStorage.getItem('profile')));
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const logout = ()=>{
        dispatch({type: 'LOGOUT'});
        navigate('/');
        setUser(null)
    }


    return (
            <Container fluid className='footerWrapper'>
                <Row style={{paddingBottom:'10px'}}>

                 <Col xl={3} lg={3} md={3} sm={3} xs={12} className='Block1' >
                    <h3 className='followUsTitle' >FOLLOW US</h3>
                            <div className='socialsBox'>
                                <div>
                                    <a className='Link-group' href='https://www.instagram.com/sai_shreyas_residency/'>
                                        <BsInstagram className='socialsIcon' /> 
                                        <span style={{color:'white'}} >Instagram</span>
                                    </a>
                                </div>
                                <div>
                                    <a className='Link-group' href='https://www.facebook.com/saishreyasresidency'>
                                        <RiFacebookCircleLine className='socialsIcon' />
                                        <span style={{color:'white'}} >Facebook</span>
                                    </a>
                                </div> 
                                <div>
                                    <a className='Link-group' href='https://www.youtube.com/channel/UCLsSZr_5hKBjaQCetM77niQ/featured'>
                                        <FiYoutube className='socialsIcon' />
                                        <span style={{color:'white'}} >YouTube</span>
                                    </a>
                                    
                                    
                                </div>
                                <div>
                                    <a className='Link-group' href='https://twitter.com/SSR_Bangalore'>
                                        <FiTwitter className='socialsIcon' />
                                        <span style={{color:'white'}} >Twitter</span>
                                    </a>
                                </div>
                                <div >
                                    <a className='Link-group' href='https://www.linkedin.com/in/sai-shreyas-residency-818242231/'>
                                        <FaLinkedinIn className='socialsIcon' />
                                        <span style={{color:'white'}} >LinkedIn</span>
                                    </a>
                                </div>
                                
                                
                                
                                
                            </div>
                 </Col>
                 
                 <Col xl={3} lg={3} md={3} sm={3} xs={12} >
                 <h4 className='underline'>Contact Us </h4>
                                    <div style={{color:'whitesmoke'}}>
                                        <div className='contact-spacing' >
                                            <GiRotaryPhone />
                                               <span style={{paddingLeft:'20px'}}>+91 8029901551</span> 
                                        </div>
                                        <div className='contact-spacing'>
                                            <BsTelephone  />
                                            
                                            <span style={{paddingLeft:'20px'}}>+91 9614385253</span> 
                                        </div>
                                        <div className='contact-spacing'>
                                            
                                            <BsWhatsapp />
                                            <span style={{paddingLeft:'20px'}}>+91 9380093384</span> 
                                        </div>
                                        <div className='contact-spacing'>
                                            
                                            <FaUserTie />
                                            <span style={{paddingLeft:'20px'}}>+91 8220583325</span> 
                                        </div>
                                        <div  className='contact-spacing'>
                                            
                                            <AiOutlineMail />
                                            <a className='contactstyle' style={{fontSize:'15px',textDecoration:'none',color:'whitesmoke'}} target="_top" href="mailTo:info@saishreyasresidency.com">
                                                {/* <span  className='contactstyle' style={{fontSize:'15px'}} >info@saishreyasresidency.com</span>  */}
                                                info@saishreyasresidency.com
                                            </a>
                                           
                                            
                                        </div>
                                        
                                        
                                    </div>
                 </Col>
                 <Col xl={3} lg={3} md={3} sm={3} xs={12} className='Address-block' >
                    <h4 className='underline' >Address</h4>
                                <p style={{color:'whitesmoke'}}> #371/11, Kadiganahalli Gate,Near Decathlon Anubhava,Bangalore North – 562157</p>
                                <div className='map-group'>
                                    <img className='Qr-class' src={QR} alt='qr' />
                                    <div style={{display:'block'}} >
                                        <a href='https://goo.gl/maps/HSXSewYo8tr6YWkP9'>
                                            <img className='map' src={GoogleMap} alt='map' />
                                        </a>
                                        
                                        <p className='text-map' style={{color:"#fff",position:'relative',left:'-40px'}} >Map</p>
                                    </div>
                                    
                                </div>
                               

                 </Col>
                 <Col xl={3} lg={3} md={3} sm={3} xs={12} >
                 <ul className='navsUl'>
                                <li className='liStyle'>
                                    <Link to='/#explore' className='navs'>ABOUT US</Link>
                                </li>
                                <li className='liStyle' >
                                    <NavLink to='' className='navs' onClick={() => setModalShow(true)} > TERMS and CONDITIONS</NavLink>
                                </li>
                                
                                <li className='liStyle'>
                                    <NavLink to='' className='navs' onClick={() => setPrivacyModalShow(true)} >PRIVACY POLICY</NavLink>
                                </li>
                                
                                <li className='liStyle'>
                                    <NavLink to='' className='navs'onClick={() => setRefundModalShow(true)} >CANCELLATION POLICY</NavLink>
                                </li>
                                <li className='liStyle'>
                                    <NavLink to='' className='navs' onClick={() => setRuleManagementShow(true)} >HOTEL RULES & MANAGEMENT POLICY</NavLink>
                                </li>
                            </ul>
                 </Col>












                    {/* <Col sm={12} md={12} lg={12} xl={6} className='Block1'> */}
                        {/* <Col sm={6} xs={12} className='subscribe-newsletter'>
                            <h3 className='title'>Subscribe to Newsletter</h3>
                            <Form>
                                <FormGroup className='subGoup'>
                                    <FormControl className='inputClass' type='email' placeholder='enter your email id'  required />
                                    <Button  type='submit' className='submitBtn'  >SUBSCRIBE</Button>
                                </FormGroup>
                            </Form>
                        </Col> */}
                        
                        {/* <Col sm={6} xs={12} className='follow-us'>
                            <h3 className='followUsTitle' >FOLLOW US</h3>
                            <div className='socialsBox'>
                                <NavLink to='https://www.instagram.com/general237/'>
                                    <BsInstagram className='socialsIcon' />
                                </NavLink>
                                <NavLink to='https://www.instagram.com/general237/'>
                                    <RiFacebookCircleLine className='socialsIcon' />
                                </NavLink>
                                <NavLink to='https://www.instagram.com/general237/'>
                                    <FiYoutube className='socialsIcon' />
                                </NavLink>
                                <NavLink to='https://www.instagram.com/general237/'>
                                    <FiTwitter className='socialsIcon' />
                                </NavLink>
                                
                            </div>
                        </Col> */}

                    {/* </Col> */}
                    {/* <Col sm={12} md={12} lg={12} xl={6} xs={12}  className='Block2' >
                       
                        <Col className='box1' lg={4} xs={4} >
                            <ul className='navsUl'>
                                <li className='liStyle'>
                                    <NavLink to='About Us' className='navs'>About Us</NavLink>
                                </li>
                                <li className='liStyle' >
                                    <NavLink to='About Us' className='navs' > Terms and conditions</NavLink>
                                </li>
                                
                                <li className='liStyle'>
                                    <NavLink to='About Us' className='navs'>Privacy policy</NavLink>
                                </li>
                                <li className='liStyle'>
                                    <NavLink to='About Us' className='navs'>Refunds/cancellation policy</NavLink>
                                </li>
                            </ul>

                        </Col>
                        
                        <Col lg={8} xs={8} className='box2' >
                            <div>
                                <h4 className='underline' >Address :</h4>
                                <p style={{color:'whitesmoke'}}> #371/11, Kadiganahalli Gate,Near Decathlon Anubhava,Bangalore North – 562157</p>
                                <h4 className='underline'>Contact Us :</h4>
                                    <div style={{color:'whitesmoke'}}>
                                        <div >
                                             
                                            
                                                <BsTelephone  />
                                               <span style={{paddingLeft:'20px'}}>08220583325</span> 
                                             
                                             
                                        </div>
                                        <div>
                                            
                                            <GiRotaryPhone />
                                            <span style={{paddingLeft:'20px'}}>08029901551</span> 
                                        </div>
                                        <div>
                                            
                                            <AiOutlineMail />
                                            <span  className='contactstyle' >info@saishreyasresidency.com</span> 
                                        </div>
                                        
                                    </div>
                                    
                                
                            </div>
                            
                        </Col>
                        
                    </Col> */}
                </Row>

                {user?<NavBtn className='verify-btn'>
                           <NavBtnLink className='verify' to="" onClick={logout}>LOGOUT</NavBtnLink>
                           
                       </NavBtn>:<NavBtn className='verify-btn'>
                           <NavBtnLink className='verify' to="/auth">LOGIN</NavBtnLink>
                                </NavBtn>
                       }
                
                <Row>
                    <hr style={{color:'#fff'}} />
                    <div className='envelop-copyright'>
                        <p >©{new Date().getFullYear()} The Sai Shreyas Residency. All Rights Reserved.</p>
                        <p>Website Designed, Developed & Maintained by Atlas (Techroot)</p>
                    </div>
                    
                </Row>

                


        <MyVerticallyCenteredModal show={modalShow}
        onHide={() => setModalShow(false)} />

        <PrivacyModal show={PrivacymodalShow}
        onHide={() => setPrivacyModalShow(false)} />

        <RefundModal show={RefundmodalShow}
        onHide={() => setRefundModalShow(false)} />

        <RulesModal show={RuleManagementShow}
        onHide={() => setRuleManagementShow(false)} />

            </Container>
            
        
    )
}

export default Footer
